<div class="maintenance-container">
  <div class="text-container">
    <span class="text" [innerHTML]="htmlTemplate">
    </span>
  </div>
</div>
